<template>
    <div v-if="requestIsSuccess">
        <span>
             {{messages.requestSent}}
        </span>
    </div>
    <div v-else>
        <div class="row">
            <div v-for="(item,index) in fields" :item="item" :key="getHtmlId('field',item.name)" class="form-group">
                <label>{{item.placeholder}}</label>
                <mask-input v-if="index === 'phone'" v-model="values[index]" :mask="messages.mask" placeholder-char="-" class="form-control"  :placeholder="item.placeholder" :type="item.type" />
                <input v-else v-model="values[index]" :type="item.type" :name="item.name" class="form-control" :placeholder="item.placeholder">
                <span style="color: red" v-if="item.error"> {{item.error}} </span>
            </div>
            <div v-if="membersCountField" class="form-group">
                {{membersCountField.title}}
                <input @input="validateQuantity" v-model="membersValue" class="form-control" :type="membersCountField.type">
            </div>
        </div>

        <button v-on:click="addCourseOrderItem" class="btn-std btn">
            {{messages.makeOrderText}}
        </button>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import _u from "jsAssets/utils/index";
    import {APP} from 'jsAssets/constants/app';
    import maskedInput from 'vue-masked-input';

    export default {
        name: "course-detail-form",

        props: [
            'course_id'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {object} messages - Текст в компоненте в зависемости от языка
         * @property {string} userName - имя заказчика
         * @property {string} userEmail - почта заказчика
         * @property {string} userPhone - телефон заказчика
         * @property {int} membersCount - Количество желающих поситить курс
         *
         */
        data() {
            return {
                fields: {},
                membersCountField: {},
                membersValue: "1",
                messages: {},
                values: {},
            }
        },


        computed: {
            ...mapGetters('course', [
                'chosenCourseID',
                'courseSchema',
                'requestIsSuccess'
            ]),

            /**
             *  Вычисляемое свойство которое возвращает ID курса для которого делается бронь
             *
             * @method getCourseId
             */
            getCourseId() {

                if(this.chosenCourseID && this.chosenCourseID !== 'undefined') {
                    return this.chosenCourseID;
                }
                return false;
            },

            getCourseSchema() {
                if(this.courseSchema && this.courseSchema.fields) {
                    return this.chosenCourseID;
                }
                return false;
            },
        },

        watch: {
            courseSchema() {
                this.setFields(this.courseSchema);
            }
        },
        mounted(){
            this.saveCourseID()
        },
        components: {
            'mask-input': maskedInput

        },
        methods: {
            /**
             *  При нажатии на кнопку идет запрос к серверу о создании заявки на курс
             *
             * @method addCourseOrderItem
             */
            addCourseOrderItem(){
                if(this.getCourseId){
                    this.$store.dispatch('course/createCourse', {
                        userName: this.values && this.values.name ? this.values.name : '',
                        userEmail: this.values && this.values.email ? this.values.email : '',
                        userPhone: this.values && this.values.phone ? this.values.phone : '',
                        courseId: this.getCourseId,
                        membersCount: this.membersValue,
                    });
                }
            },

            /**
             * Проверяем input на соблюдение условий и если нужно миняем значение на 1
             *
             * @method validateQuantity
             */
            validateQuantity() {
                if (this.membersValue <= 0) {
                    this.$nextTick(() => {
                        this.membersValue = 1;
                    });
                }
            },

            setFields(FormSchema)
            {
                this.fields = FormSchema.fields;
                for(var index in this.fields) {
                    this.values[index] = this.fields[index].value.slice(0);
                };
                this.membersCountField = FormSchema.memberCount;
                this.membersValue = this.membersCountField.value;
                this.messages = FormSchema.messages;
            },

            /**
             *  При нажатии на кнопку сохраняем ID курса
             *
             * @method addCourseOrderItem
             */
            saveCourseID(){
                this.$store.dispatch('course/getSchema');
                this.$store.commit('course/setChosenCourseID',this.course_id);
            },
        }
    }


</script>
